import * as Api from '@ViewModels';
import { useAccountUsesRegEd } from './useAccountUsesRegEd';
import { useRegEdIntegrationQuery } from './useRegEdIntegrationQuery';

/**
 * Whether the firm's compliance officer files through the review portal rather than the advisor filing
 * in-app. Built on [[useAccountUsesRegEd]] so both answers move together — an account that isn't
 * routing through RegEd at all has no officer-filing mode to be in.
 *
 * Fail-closed to advisor filing while loading or on error: guessing the other way would hide the
 * questionnaire that is the account's only way to file.
 */
export const useAccountOfficerFilesRegEd = (
	impersonationContext?: Api.IImpersonationContext,
	{ enabled = true }: { enabled?: boolean } = {}
): boolean => {
	const usesRegEd = useAccountUsesRegEd(impersonationContext, { enabled });
	const { data } = useRegEdIntegrationQuery({ impersonationContext, enabled });
	return usesRegEd && data?.officerFilesSubmissions === true;
};
